const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Set+Nickname+API


function setNickname(nickname, provider, source) {
    const url = '/api/users/profile/nickname';
    const params = {
        isAcceptCommunity: true,
        nickName: nickname,
        provider
    };
    if (source) {
        params.source = source;
    }
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(params)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = setNickname;
